import React from "react"
import { Link } from "react-router-dom"
import useViewSale from "../../../controllers/useViewSale"
import { currencyFormatter, dateFormatter, normalizeText } from "../../../utils/helperFunctions"
import ImageWithBasePath from "../../img/imagewithbasebath"
import TableTop from "../../tabletop"

const ViewSales = (props) => {

    const { values: { data, loading }, functions: { refetch, onDownload } } = useViewSale(props)

    return (

        <div className="modal fade" id="sales-details-new">
            <div className="modal-dialog sales-details-modal">
                <div className="modal-content">
                    <div className="page-wrapper details-blk">
                        <div className="content p-0">
                            <div className="page-header p-4 mb-0">
                                <div className="add-item d-flex">
                                    <div className="page-title modal-datail d-flex justify-content-center align-items-center">
                                        <h4 className="m-0">Sales Detail #{data?.invoice_no}</h4>
                                        {
                                            data &&
                                            <span
                                                className={`ms-3 badges ${data?.status === "Completed"
                                                    ? "bg-lightgreen"
                                                    : data?.status === "InProgress"
                                                        ? "bg-lightyellow"
                                                        : "bg-lightred"
                                                    }`}
                                            >
                                                {normalizeText(data?.status)}
                                            </span>
                                        }
                                    </div>
                                </div>
                                <TableTop
                                    onPdf={onDownload}
                                    onRefresh={() => refetch()}
                                    onEdit={() => { }}
                                    hideCollapse={true}
                                />
                            </div>
                            {
                                loading ?
                                    <div className="d-flex justify-content-center mb-4">
                                        <div className="spinner-border text-primary me-1" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    </div> :
                                    <div className="card">
                                        <div className="card-body">
                                            <form>
                                                <div className="invoice-box table-height">
                                                    <div className="sales-details-items d-flex">
                                                        <div className="details-item">
                                                            <h6>Customer Info</h6>
                                                            <p>
                                                                {data?.customer?.full_name}
                                                                <br />
                                                                {data?.customer?.email}
                                                                <br />
                                                                {data?.customer?.phone}
                                                            </p>
                                                        </div>
                                                        <div className="details-item">
                                                            <h6>Company Info</h6>
                                                            <p>
                                                                {data?.customer?.business?.[0]?.name}
                                                                <br />
                                                                {data?.customer?.business?.[0]?.address?.address}
                                                                <br />
                                                                {data?.customer?.business?.[0]?.address?.city}, {data?.customer?.business?.[0]?.address?.state}, {data?.customer?.business?.[0]?.address?.zip}
                                                            </p>
                                                        </div>
                                                        <div className="details-item">
                                                            <h6>Invoice Info</h6>
                                                            <p>
                                                                Order Date
                                                                <br />
                                                                Invoice Date
                                                                <br />
                                                                Payment Status
                                                                <br />
                                                                Status
                                                                <br />
                                                                Invoice Prepared By
                                                                <br />
                                                                Representative Name
                                                            </p>
                                                        </div>
                                                        <div className="details-item">
                                                            <h6>#{data?.invoice_no}</h6>
                                                            <p>
                                                                {dateFormatter(data?.sale_date)}
                                                                <br /> {dateFormatter(data?.createdAt)}
                                                                <br /> <span className={`fw-bold ${data?.payment_status === "Paid"
                                                                    ? "text-success"
                                                                    : "text-danger"
                                                                    }`}>{normalizeText(data?.payment_status)}</span>
                                                                <br /> <span className={`fw-bold ${data?.status === "Completed"
                                                                    ? "text-success"
                                                                    : data?.status === "InProgress"
                                                                        ? "text-warning"
                                                                        : "text-danger"
                                                                    }`}>{normalizeText(data?.status)}</span>
                                                                <br /> {normalizeText(data?.user?.full_name)}
                                                                <br /> {normalizeText(data?.customer?.user?.full_name)}
                                                            </p>
                                                        </div>
                                                        {/* <div className="details-item">
                                                    <h5>
                                                        <span>SL0101</span>Paid
                                                        <br /> Completed
                                                    </h5>
                                                </div> */}
                                                    </div>
                                                    <h5 className="order-text">Order Summary</h5>
                                                    <div className="table-responsive no-pagination">
                                                        <table className="table datanew">
                                                            <thead>
                                                                <tr>
                                                                    <th>S. No</th>
                                                                    <th>Product</th>
                                                                    <th>Qty</th>
                                                                    <th>Unit Cost</th>
                                                                    <th>Total Cost</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    data?.sale_items?.map((item, index) => (
                                                                        <tr key={item.id}>
                                                                            <td>{index + 1}</td>
                                                                            <td>
                                                                                <div className="productimgname">
                                                                                    <Link
                                                                                        to="#"
                                                                                        className="product-img stock-img"
                                                                                    >
                                                                                        <ImageWithBasePath
                                                                                            alt="product"
                                                                                            src={
                                                                                                item?.product?.images?.length > 0
                                                                                                    ? item?.product?.images?.[0]
                                                                                                    : "assets/img/product/noimage.png"
                                                                                            }
                                                                                            isApiImage={
                                                                                                item?.product?.images?.length > 0
                                                                                                    ? true
                                                                                                    : false
                                                                                            }
                                                                                        />
                                                                                    </Link>
                                                                                    <Link to="#">{item?.product?.name}</Link>
                                                                                </div>
                                                                            </td>
                                                                            <td>{item?.quantity}</td>
                                                                            <td>{currencyFormatter(item?.price)}</td>
                                                                            <td>{currencyFormatter(item?.quantity * item?.price)}</td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="row">
                                                        <div className="col-lg-6 ms-auto">
                                                            <div className="total-order w-100 max-widthauto m-auto mb-4">
                                                                <ul>
                                                                    <li>
                                                                        <h4>Subtotal</h4>
                                                                        <h5>{currencyFormatter(data?.sale_items?.reduce((prev, next) => prev + (next.price * next.quantity), 0))}</h5>
                                                                    </li>
                                                                    <li>
                                                                        <h4>Tax</h4>
                                                                        <h5>{currencyFormatter(data?.sale_tax)}</h5>
                                                                    </li>
                                                                    <li>
                                                                        <h4>Shipping</h4>
                                                                        <h5>{currencyFormatter(data?.shipping)}</h5>
                                                                    </li>
                                                                    <li>
                                                                        <h4>Discount</h4>
                                                                        <h5>{currencyFormatter(data?.discount)}</h5>
                                                                    </li>
                                                                    <li>
                                                                        <h4 className="fw-bold">Grand Total</h4>
                                                                        <h5 className="fw-bold">{currencyFormatter(data?.total_amount)}</h5>
                                                                    </li>
                                                                    <li>
                                                                        <h4>Paid</h4>
                                                                        <h5>{currencyFormatter(data?.paid)}</h5>
                                                                    </li>
                                                                    <li>
                                                                        <h4>Due</h4>
                                                                        <h5>{currencyFormatter(data?.due)}</h5>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ViewSales